import { useTranslation } from "react-i18next";
import one from "./icons/1.svg";
import two from "./icons/2.svg";
import three from "./icons/3.svg";
import four from "./icons/4.svg";

export function Benefits() {
  const { t } = useTranslation();
  return (
    <div className="my-24">
      <h2>{t("CaboCheck Vorteile")}</h2>
      <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {benefits.map((benefit) => (
          <BenefitItem key={benefit.id} benefit={benefit} />
        ))}
      </div>
    </div>
  );
}

export type TBenefit = {
  id: string;
  title: string;
  image: string;
};

export const benefits: TBenefit[] = [
  {
    id: "1",
    title: "Professionelle Probenentnahme vor Ort in der Apotheke",
    image: one,
  },
  {
    id: "2",
    title: "Einfache Kapillarblutentnahme innerhalb von 2 Minuten",
    image: two,
  },
  {
    id: "3",
    title: "Auswertung durch medizinisches Facharztlabor",
    image: three,
  },
  {
    id: "4",
    title: "Labor-Ergebnisse als PDF oder online",
    image: four,
  },
];

export function BenefitItem({ benefit }: { benefit: TBenefit }) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-gray-200 bg-white p-12 text-center">
      <img src={benefit.image} alt={benefit.title} />
      <p>{benefit.title}</p>
    </div>
  );
}
